import { ToggleSwitch } from "flowbite-react";
import tenkenTheme from "../../configs/themes/tenkenTheme";

const ToggleDisplay = ({ column, label, disabled, onChange, checked }) => {
  return (
    <div className="flex justify-between border-[0.5px] border-tenken-gray-200">
      <div className="judgment__setting-modal--content">
        <label>{label}</label>
      </div>
      <div className="judgment__setting-modal--toggle">
        <div className="flex items-center md:min-w-[146px] xl:min-w-[146px]">
          <label className="inline-block mr-2" onClick={() => onChange(column, false)}>
            非表示
          </label>
          <ToggleSwitch
            theme={tenkenTheme}
            color="primary"
            disabled={disabled}
            checked={checked}
            onChange={(e) => onChange(column, e)}
          />
          <label className="inline-block mr-2" onClick={() => onChange(column, true)}>
            表示
          </label>
        </div>
      </div>
    </div>
  );
};

export default ToggleDisplay;
